import widgetDesign from 'widget/widget-design';

const { defaultStyle } = widgetDesign;

const design = {
  rolloutContainer: (color = '#3e58f5', align = 'right') => ({
    ...defaultStyle,
    width: '75px',
    // the max-width below is to override the css of some clients that have a
    // global * {max-width: 100% !important;}
    // https://m.the-royalpark.jp/the/kyotosanjo/en/
    'max-width': ['none', 'important'],
    height: '40px',
    'background-color': color,
    opacity: 0,
    left: align === 'left' ? '110px' : 'auto', // There is a translateX(-20px) transform
    right: align === 'left' ? 'auto' : '110px', // There is a translateX(20px) transform
    bottom: '20px',
    'border-radius': '6px',
    position: 'absolute',
    'box-shadow': '0px 2px 10px 1px #b5b5b5',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'space-evenly',
  }),
  rolloutCircle: {
    ...defaultStyle,
    width: '8px',
    height: '8px',
    'background-color': 'white',
    'border-radius': '50%',
    opacity: 0.3,
  },
  rolloutCarret: (color = '#3e58f5', align = 'right') => ({
    ...defaultStyle,
    content: '',
    display: 'block',
    position: 'absolute',
    height: 0,
    width: 0,
    'border-top': '5px solid transparent',
    'border-bottom': '5px solid transparent',
    'border-left': align === 'left' ? `auto` : `6px solid ${color}`,
    'border-right': align === 'left' ? `6px solid ${color}` : 'auto',
    top: '50%',
    right: align === 'left' ? 'auto' : '-6px',
    left: align === 'left' ? '-6px' : 'auto',
    'margin-top': '-4px',
  }),
  rolloutButtonStyle: {
    ...defaultStyle,
    opacity: 0,
    display: 'none',
    padding: '10px 15px',
    cursor: 'pointer',
    'max-width': '100%',
  },
  rolloutTextStyle: {
    ...defaultStyle,
    color: 'white',
    'line-height': 1.1,
    'font-size': '15px',
    'font-weight': '200',
    'text-align': 'left',
    // The following is like `text-overflow: ellipsis`, but for 2 lines of text. Despite
    // the '-webkit-' prefix, it does actually work in other browsers (like Firefox)
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    overflow: 'hidden',
  },
  rolloutCloseButton: {
    ...defaultStyle,
    color: 'white',
    cursor: 'pointer',
    position: 'absolute',
    right: '0',
    top: '0',
    '-webkit-tap-highlight-color': 'rgba(255, 255, 255, 0)',
    'font-size': '16px',
    opacity: 0,
    width: '1.5em',
    height: '1.5em',
    'vertical-align': 'middle',
    'text-align': 'center',
    'padding-left': '1px',
  },
};

export default design;
